import { Version, VersionedSnippet } from '@cld/code-snippet-next';
import { SdkSnippet } from '../types';
import { getPackageName } from './getPackageName';
import { getSdkSnippetSyntax } from './getSdkSnippetSyntax';

/**
 * Group snippets by sdk pkg versions fetched from CodeSnippets service
 */
export const groupSnippets = (sdkSnippets: SdkSnippet[]): VersionedSnippet[] => {
  const snippetsMap: Record<string, SdkSnippet[]> = {};
  sdkSnippets.forEach((s: SdkSnippet) => {
    const existingSnippet = snippetsMap[s.displayName];
    snippetsMap[s.displayName] = existingSnippet ? [...existingSnippet, s] : [s];
  });

  return Object.entries(snippetsMap).map(([displayName, sdks]) => ({
    language: displayName,
    versions: sdks.map((sdk) => {
      const versionName = getPackageName(sdk);
      const version: Version = {
        snippet: sdk.codeSnippet,
        sdkId: sdk.sdkId,
        syntax: getSdkSnippetSyntax(sdk),
      };

      if (versionName) {
        version.versionName = versionName;
      }

      return version;
    }),
  }));
};
